import React, { Component } from "react";
import styles from "./style.module.scss";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { Icon, Layout, Menu, Modal } from "antd";
import GroupOverview from "../groupOverview";
import Settings from "../settings";
import InviteMemberPage from "../inviteMember";
import MonthlyReportPage from "../monthlyReport";
import UserInfo from "../../store/userInfo";
import Membership from "../../store/membership";
import HelpMePage from "../helpMe";
import AchievementsPage from "../achievements";
import BasicDashboard from "../basicDashboard";
import GroupDashboard from "../GroupDashboard";
import styled from "styled-components";
import MemberList from "../memberList";
import GroupDetail from "../groupDetail";
import AdvancedDashboard from "../advancedDashboard";

const CustomMenu = styled(Menu)`
&& .ant-menu-item-selected {
background-color: #6001d9;
}}`;

interface MenuItemType {
  iconName: string;
  key: string;
  path: string;
}
const BASIC_MENU_DATA: Array<MenuItemType> = [
  {
    iconName: "home",
    key: "Home",
    path: "/admin/home",
  },
  {
    iconName: "column-width",
    key: "Group overview",
    path: "/admin/group-overview",
  },
  {
    iconName: "schedule",
    key: "Monthly report",
    path: "/admin/monthly-report",
  },
  {
    iconName: "sketch",
    key: "Achievements",
    path: "/admin/achievements",
  },
  {
    iconName: "team",
    key: "All members",
    path: "/admin/members",
  },
  {
    iconName: "plus-circle",
    key: "New members",
    path: "/admin/invite-member",
  },
  {
    iconName: "setting",
    key: "Settings",
    path: "/admin/settings",
  },
  {
    iconName: "info-circle",
    key: "Need help?",
    path: "/admin/help",
  },
];

@observer
export default class BasicLayout extends Component<RouteComponentProps<{}>> {
  @observable menuSelectedKey = BASIC_MENU_DATA[0].key;
  @observable menuItems = BASIC_MENU_DATA;

  async componentDidMount() {
    if (!UserInfo.token) {
      this.props.history.replace("/");
    } else {
      const { pathname } = this.props.location;
      const menuItem = this.menuItems.find((e) => pathname.includes(e.path));
      if (menuItem) {
        this.menuSelectedKey = menuItem.key;
      }

      await Membership.fetchMemberships();
    }
  }

  render() {
    return (
      <Layout className={styles.container}>
        {this._renderMenuBar()}
        {this._renderRight()}
      </Layout>
    );
  }

  _renderMenuBar = () => {
    return (
      <Layout.Sider width={190} collapsible={false}>
        <div className={styles.menu_bar_header}>
          <img src={require("./yomento_logo.png")} className={styles.yomento} />
          <span>Leadership Dashboard</span>
        </div>
        <CustomMenu
          theme="dark"
          selectedKeys={[this.menuSelectedKey]}
          mode="inline"
          onClick={this._onClickMenuItem}
        >
          {this.menuItems.map(this._renderMenu)}
        </CustomMenu>
      </Layout.Sider>
    );
  };

  _renderMenu = (menu: MenuItemType) => {
    if (menu.path) {
      return (
        <Menu.Item key={menu.key}>
          <Icon type={menu.iconName} />
          <span>{menu.key}</span>
        </Menu.Item>
      );
    }
  };

  _renderRight = () => {
    return (
      <Layout>
        <Layout.Header className={styles.content_header}>
          <span>{UserInfo.email}</span>
          <div className={styles.admin_button} onClick={this._onClickLogout}>
            <Icon type="poweroff" className={styles.admin_icon} />
            Logout
          </div>
        </Layout.Header>

        <Layout.Content className={styles.content_box}>
          <Switch>
            {/* <Route path="/admin/home" component={AdvancedDashboard} /> */}
            <Route path="/admin/home" component={BasicDashboard} />
            <Route path="/admin/advancedDashboard" component={AdvancedDashboard} />
            <Route path="/admin/group-detail" component={GroupDetail} />
            <Route path="/admin/group-invite" component={InviteMemberPage} />
            <Route path="/admin/group-overview" component={GroupOverview} />
            <Route path="/admin/achievements" component={AchievementsPage} />
            <Route path="/admin/members" component={MemberList} />
            <Route path="/admin/invite-member" component={InviteMemberPage} />
            <Route path="/admin/monthly-report" component={MonthlyReportPage} />
            <Route path="/admin/settings" component={Settings} />
            <Route path="/admin/help" component={HelpMePage} />
            <Redirect to="/admin/home" />
          </Switch>
        </Layout.Content>

        <Layout.Footer className={styles.footer}>
          Copyright <Icon type="copyright" /> {new Date().getFullYear()} Yomento
        </Layout.Footer>
      </Layout>
    );
  };

  _onClickMenuItem = (item: { key: string }) => {
    const menuItem = this.menuItems.find((e) => e.key === item.key);

    if (menuItem) {
      this.menuSelectedKey = menuItem.key;
      this.props.history.push(menuItem.path);
    }
  };

  _onClickLogout = () => {
    Modal.confirm({
      title: "Are you sure to logout?",
      okText: "Logout",
      onOk: this._doLogout,
    });
  };

  _doLogout = () => {
    UserInfo.clearToken();
    this.props.history.replace("/login");
  };
}
